import React, { Fragment } from 'react';
import { IntlProvider } from 'react-intl';

import { LOCALES } from './locales';

import messagesAdmin from './messages/admin';
import messagesDeveloper from './messages/developer';
import messagesAppGallery from './messages/app-gallery';

function messages(app) {
  switch (app) {
    case 'admin':
      return messagesAdmin;
    case 'developer':
      return messagesDeveloper;
    case 'app-gallery':
      return messagesAppGallery;
    default:
      return messagesDeveloper;
  }
}

const Provider = ({ children, locale = LOCALES.ENG, appTranslate }) => (
  <IntlProvider
    locale={locale}
    textComponent={Fragment}
    messages={messages(appTranslate)[locale]}
  >
    {children}
  </IntlProvider>
);

export default Provider;
